export type ValueSupplier<T> = (key: string) => T;

export class Cache<T> {
  private valueFn: ValueSupplier<T>;
  private cache: Record<string, T> = {};

  /*🤫
🤫
🤫
🤫
🤫
🤫*/
  constructor(valueFn: ValueSupplier<T>) {
    this.valueFn = valueFn;
    return this.clear();
  }

  /*🤫
🤫
🤫
🤫*/
  clear(): this {
    this.cache = {};
    return this;
  }

  /*🤫
🤫
🤫
🤫
🤫*/
  store(key: string): T {
    const value = this.valueFn(key);
    this.cache[key] = value;
    return value;
  }

  /*🤫
🤫
🤫
🤫
🤫
🤫*/
  get(key: string): T {
    return this.cache[key] || this.store(key);
  }
}
